<template>
    <div>
        <DaiLineas
            :linea_id="'porcentaje-pacientes-por-tiempo'"
            :datos="datos_porcentaje_pacientes_tiempo"
            :nombre_clumna_horizontal="'anio_mes'"
            :variables_categorias="variables_serie_porcentaje_pacientes"
            :titulo_tooltip="'Tooltip de seleccion'"
            :titulo_eje_y="'Cantidad de participantes'"
            :titulo_eje_x="'Fecha'"
            class="contenedor-grafica flex-1"
            :conversionTemporal="conversionTemporal"
            :textoTooltip="textoTooltipPorcentajePacientes"
            ref="porcentaje-pacientes-por-tiempo"
            :ancho_tooltip = "200"
            :margen="margen_lineas"
            >
            <template slot="encabezado">
              <div class="encabezado">
                <h5 class="titulo-visualizacion">Participantes que conforman un conglomerado</h5>
                <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
                <p class="instruccional"> El porcentaje de los participantes que pertenecen a un conglomerado (con respecto al total de participantes a la fecha señalada) va cambiando a través del tiempo, debido a que las nuevas personas que se unen al estudio se pueden integrar a conglomerados ya existentes o formar nuevos.</p>
              </div>
            </template>
            <template slot="pie" >
              <div class="pie">
                <div class="titulo-switch leyenda-barras-apiladas">
                  <div class="titulo-switch">
                    <div class="nomenclatura">
                      <div class="checkbox suspension">
                        <span class="color" v-bind:style="{background: color_ventana_sarscov2}"></span>
                        <span class="nombre">Periodo de suspensión por SARS-CoV-2</span>
                      </div>
                    </div>
                    <div class="contenedor-switch">
                      <button class="button-left farmaco" :class="{activo: tipo_dato_lineas_porcentaje_pacientes=='no_acumulado'}" @click="cambioTipoDatoLineasPorcentajesPacientes('no_acumulado')">
                        Mensual
                      </button>
                      <button class="button-right" :class="{activo: tipo_dato_lineas_porcentaje_pacientes=='acumulado'}" @click="cambioTipoDatoLineasPorcentajesPacientes('acumulado')">
                        Acumulado
                      </button>
                    </div>
                  </div>
                </div>
                <PieComponenteLibreria />
              </div>
            </template>
        </DaiLineas>
        <DaiLineas
            :linea_id="'numero-conglomerados-por-tiempo'"
            :datos="datos_conglomerados_acumulados_tiempo"
            :nombre_clumna_horizontal="'anio_mes'"
            :variables_categorias="variables_serie_numero_conglomerados"
            :titulo_tooltip="'Tooltip de seleccion'"
            :titulo_eje_y="'Cantidad de conglomerados'"
            :titulo_eje_x="'Fecha'"
            class="contenedor-grafica flex-1"
            :conversionTemporal="conversionTemporal"
            :textoTooltip="textoTooltipNumeroConglomerados"
            ref="numero-conglomerados-por-tiempo"
            :ancho_tooltip = "200"
            :margen="margen_lineas"
            >
            <template slot="encabezado">
              <div class="encabezado">
                <h5 class="titulo-visualizacion">Número de conglomerados en el tiempo</h5>
                <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
                <p class="instruccional"> El número de conglomerados cambia a lo largo del tiempo debido a que nuevos participantes se integran a conglomerados ya existentes o forman nuevos conglomerados</p>
              </div>
            </template>
            <template slot="pie" >
              <div class="pie">
                <div class="titulo-switch leyenda-barras-apiladas">
                  <div class="titulo-switch">
                    <div class="nomenclatura">
                      <div class="checkbox suspension" >
                        <span class="color" v-bind:style="{background: color_ventana_sarscov2}"></span>
                        <span class="nombre">Periodo de suspensión por SARS-CoV-2</span>
                      </div>
                    </div>
                    <div class="contenedor-switch">
                      <button class="button-left farmaco" :class="{activo: tipo_dato_lineas_numero_conglomerados=='no_acumulado'}" @click="cambioTipoDatoLineasConglomeradosAcumulados('no_acumulado')">
                        Mensual
                      </button>
                      <button class="button-right" :class="{activo: tipo_dato_lineas_numero_conglomerados=='acumulado'}" @click="cambioTipoDatoLineasConglomeradosAcumulados('acumulado')">
                        Acumulado
                      </button>
                    </div>
                  </div>
                </div>
                <PieComponenteLibreria />
              </div>
            </template>
        </DaiLineas>
    </div>
</template>
<script>
import * as d3 from "d3";
import DaiLineas from '@/components/graficas/DaiLineas.vue';
import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';

import { mapState } from "vuex";

var lista_meses = [
	"enero",
	"febrero",
	"marzo",
	"abril",
	"mayo",
	"junio",
	"julio",
	"agosto",
	"septiembre",
	"octubre",
	"noviembre",
	"diciembre",
]
var lista_meses_abr = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic",
]
export default {
	name: 'App',
    components: {
        DaiLineas,
        PieComponenteLibreria
    },
    data(){
        return {
            conversionTemporal: d3.timeParse('%Y-%m'),
            datos_porcentaje_pacientes_tiempo:[],
            variables_serie_porcentaje_pacientes:[
                {"cve": "porcentaje_de_personas_cong_no_acum",
                "nombre": "numero de conglomerados por mes",
                "abr":"numero de conglomerados por mes",
                "color":"#445DE1","resaltado": false},
            ],
            color_ventana_sarscov2:"#F0F0F0",
            tipo_dato_lineas_porcentaje_pacientes: "no_acumulado",

            datos_conglomerados_acumulados_tiempo:[],
            variables_serie_numero_conglomerados:[
                {"cve": "num_conglomerados_no_acum",
                "nombre": "numero de conglomerados por mes",
                "abr":"numero de conglomerados por mes",
                "color":"#7C38FB","resaltado": false},
            ],
            tipo_dato_lineas_numero_conglomerados: "no_acumulado",

            margen_lineas:{arriba: 10, abajo: 50, izquierda: 30, derecha: 30}
        }
    },
    mounted(){
		d3.csv('data/pacientes_en_conglomerados.csv').then((data) => {
            data.forEach((d)=>{
                d.porcentaje_de_personas_cong_acum = +d.porcentaje_de_personas_cong_acum;
                d.porcentaje_de_personas_cong_no_acum = +d.porcentaje_de_personas_cong_no_acum;
                d.tooltip_personas_en_cong_acum = +d.tooltip_personas_en_cong_acum
            })
            this.datos_porcentaje_pacientes_tiempo = data;
            this.reescalandoPantalla()

		})
        d3.csv('data/numero_de_conglomerados.csv').then((data) => {
            data.forEach((d)=>{
                d.num_conglomerados_acum = +d.num_conglomerados_acum;
                d.num_conglomerados_no_acum = +d.num_conglomerados_no_acum;
            })
            this.datos_conglomerados_acumulados_tiempo = data;
                this.reescalandoPantalla()

		})

        window.addEventListener("resize", this.reescalandoPantalla);
    },
    methods: {
        agregarRectanguloLineas(grafica_ref){
            setTimeout(()=>{
                this.$refs[grafica_ref]?.grupo_frente
                    .select("rect.ventana-temporal").remove()
                this.$refs[grafica_ref]?.grupo_frente
                    .append("rect")
                    .attr("class","ventana-temporal")
                    .style("fill",this.color_ventana_sarscov2)
                    .attr("x",this.$refs[grafica_ref].escalaX(this.$refs[grafica_ref]?.conversionTemporal("2020-03")))
                    .attr("y",0)
                    .attr("width",this.$refs[grafica_ref]?.escalaX(this.$refs[grafica_ref]?.conversionTemporal("2020-07"))
                    -this.$refs[grafica_ref]?.escalaX(this.$refs[grafica_ref]?.conversionTemporal("2020-03")))
                    .attr("height",this.$refs[grafica_ref]?.height)
                //this.modificandoEtiquetasLineas(grafica_ref)

            },300)
        },
        cambioTipoDatoLineasPorcentajesPacientes(nv){
            this.tipo_dato_lineas_porcentaje_pacientes = nv
            this.agregarRectanguloLineas("porcentaje-pacientes-por-tiempo")
            if(nv == "no_acumulado"){
                this.variables_serie_porcentaje_pacientes =[
                    {"cve": "porcentaje_de_personas_cong_no_acum",
                    "nombre": "numero de conglomerados por mes",
                    "abr":"numero de conglomerados por mes",
                    "color":"#445DE1","resaltado": false}]
            }else{
                this.variables_serie_porcentaje_pacientes =[
                    {"cve": "porcentaje_de_personas_cong_acum",
                    "nombre": "numero de conglomerados por mes",
                    "abr":"numero de conglomerados por mes",
                    "color":"#445DE1","resaltado": false}]

            }
            setTimeout(()=>
                    this.$refs["porcentaje-pacientes-por-tiempo"]?.eje_y.selectAll("text").text((d) =>d + "%")
                    ,250)
        },
        cambioTipoDatoLineasConglomeradosAcumulados(nv){
            this.tipo_dato_lineas_numero_conglomerados = nv
            this.agregarRectanguloLineas("numero-conglomerados-por-tiempo")
            if(nv == "no_acumulado"){
                this.variables_serie_numero_conglomerados =[
                    {"cve": "num_conglomerados_no_acum",
                    "nombre": "numero de conglomerados por mes",
                    "abr":"numero de conglomerados por mes",
                    "color":"#7C38FB","resaltado": false}]
            }else{
                this.variables_serie_numero_conglomerados =[
                    {"cve": "num_conglomerados_acum",
                    "nombre": "numero de conglomerados por mes",
                    "abr":"numero de conglomerados por mes",
                    "color":"#7C38FB","resaltado": false}]

            }
        },
        
        reescalandoPantalla(){
            this.agregarRectanguloLineas("porcentaje-pacientes-por-tiempo")
            this.agregarRectanguloLineas("numero-conglomerados-por-tiempo")
            setTimeout(()=>
                this.$refs["porcentaje-pacientes-por-tiempo"]?.eje_y.selectAll("text").text((d) =>d + "%")
            ,250)

            if(window.innerWidth < 450){
			this.margen_lineas=  {arriba: 10, abajo: 50, izquierda: 40, derecha: 30}
			setTimeout(()=>{
				this.$refs["porcentaje-pacientes-por-tiempo"]?.eje_x.selectAll("text").attr("transform","rotate(-50)translate(-6,-12)").style("text-anchor","end").style("dominant-baseline","middle");
				this.$refs["numero-conglomerados-por-tiempo"]?.eje_x.selectAll("text").attr("transform","rotate(-50)translate(-6,-12)").style("text-anchor","end").style("dominant-baseline","middle");
            },200)

		}
		else{
			this.margen_lineas =  {arriba: 10, abajo: 20, izquierda: 40, derecha: 30}
			setTimeout(()=>{
				this.$refs["porcentaje-pacientes-por-tiempo"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle");
				this.$refs["numero-conglomerados-por-tiempo"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle");
            },200)

			}

        },
        textoTooltipPorcentajePacientes(){
			let cifras_variables = this.$refs["porcentaje-pacientes-por-tiempo"]?.variables_categorias.map((d) => `<li>
				<span class="span-tooltip-color" style="background: ${d.color} "></span>
				Porcentaje de participantes ${this.tipo_dato_lineas_porcentaje_pacientes =="no_acumulado" ? " al mes ":" acumulado "} que conforman conglomerados:
                <b>${this.tipo_dato_lineas_porcentaje_pacientes =="no_acumulado" ? this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.porcentaje_de_personas_cong_no_acum : this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.porcentaje_de_personas_cong_acum}%</b>
				(No. de personas: ${this.tipo_dato_lineas_porcentaje_pacientes =="no_acumulado" ? this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.tooltip_personas_en_cong_no_acum.toLocaleString("en") : this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.tooltip_personas_en_cong_acum.toLocaleString("en")})
				</li>`)


            return `
                <p>
                    Fecha: ${lista_meses[this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.fech.getMonth()]} / ${this.$refs["porcentaje-pacientes-por-tiempo"]?.tooltip_data_seleccionada.fech.getFullYear()}
                </p>
                <ul class="tooltip-lineas">${cifras_variables.join("")}</ul>`
        },
        textoTooltipNumeroConglomerados(){

			let cifras_variables = this.$refs["numero-conglomerados-por-tiempo"]?.variables_categorias.map((d) => `<li>
				<span class="span-tooltip-color" style="background: ${d.color} "></span>
				Número de conglomerados
                ${this.tipo_dato_lineas_numero_conglomerados =="no_acumulado" ? "al mes": "acumulados"}:
                <b>${this.tipo_dato_lineas_numero_conglomerados =="no_acumulado" ? this.$refs["numero-conglomerados-por-tiempo"]?.tooltip_data_seleccionada.num_conglomerados_no_acum : this.$refs["numero-conglomerados-por-tiempo"]?.tooltip_data_seleccionada.num_conglomerados_acum }</b>
				</li>`)
			return `
                <p>
                    Fecha: ${lista_meses[this.$refs["numero-conglomerados-por-tiempo"]?.tooltip_data_seleccionada.fech.getMonth()]} / ${this.$refs["numero-conglomerados-por-tiempo"]?.tooltip_data_seleccionada.fech.getFullYear()}
                </p>
                <ul class="tooltip-lineas">${cifras_variables.join("")}</ul>`
        },
    },
  computed: {
    ...mapState({
			fecha_actualizacion: state => `Última Actualización: ${state['fechaActualizacion']}`
		}),
  },
}

</script>

<style lang="scss" scoped>
div#porcentaje-pacientes-por-tiempo::v-deep, div#numero-conglomerados-por-tiempo::v-deep {
    div.tooltip{
      div.tooltip-cuerpo{
      font-size: 12px;
        p{
          margin: 0;
        }
        ul.tooltip-lineas{
          margin: 0;
          padding: 5px 0 0 0;
          li{
            list-style: none;
            margin: 0 0 5px 0;
            font-size: 12px;
            &::before {
              background: transparent;
            }
            span.span-tooltip-color {
              transform: translateY(2px);
              width: 12px;
              height: 12px;
				      border: solid 1px rgba(255, 255, 255, .7 );
              display: inline-block;
              border-radius: 50%;
            }
          }
        }
      }
    }

  }
div.contenedor-grafica{
    margin: 24px 0;
    background: #fff;
	width: 100%;
    border: solid black 1px;
    border-radius: 10px;
    position: relative;
    div.encabezado{
        .titulo-proyecto {
            padding: 10px 10px 0px 10px;
            text-align: right;
            font-size: 12px;
            display: inherit;
        }
        .titulo-visualizacion {
                font-size: 16px;
                padding: 10px 10px 0;
                margin: 0;
        }
        .fecha-actualizacion {
                font-size: 12px;
                padding: 0 10px;
                margin: 5px 0;
        }
        .instruccional {
                font-size: 12px;
                padding: 0 10px;
                margin: 5px 0;
        }
    }
    div.nomenclatura{

        display: flex;
        justify-content: flex-end;
        @media (max-width: map-get($media-queries-limit, "mobile")) {
            justify-content: center;
        }
        margin: 13px 10px auto auto;
        width: 100%;

        div.checkbox.suspension{
            margin: 0;
            display: flex;
            .color{
                border-radius: 0;
                width: 20px;
                border: 1px solid #707070;
                min-width: 20px;
                height: 20px;
            }
            .nombre {
                font-size: 12px;
                line-height: 1.6;
                padding-left: 10px;
            }
        }
    }
    div.leyenda-barras-apiladas{

        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        border-radius: 15px;
        box-shadow: 0px -5px 5px -1px rgb(221, 221, 221);
        margin-bottom:10px;
        div.titulo-switch{
            display: flex;
            width: 100%;
            flex-wrap: nowrap;
            @media (max-width: map-get($media-queries-limit, "mobile")) {
                flex-wrap: wrap;
                flex-direction: column-reverse;
            }
            p.titulo-leyenda{
                width: 100%;
                margin-bottom: 5px;
                text-align: center;
                font-size: 12px;
                font-weight: 700;
            }
            div.contenedor-switch{
                display: inline-flex;
                margin: 10px  20px 0 0;
                @media (max-width: map-get($media-queries-limit, "mobile")) {
                    margin: 10px  20px 0 auto;
                }
                box-shadow: 0px 3px 6px #00000029;
                max-height:24px;

                button{
                    font-size: 12px;
                    margin: 0px;
                    &.button-right{
                        border-radius:  0 3px 3px 0;
                    }
                    &.button-left{
                        border-radius:  3px 0 0 3px;
                        &.farmaco{
                            width:90px;
                        }
                    }
                    &.activo {
                        background: #FFFFFF;
                        color: #141414;
                        text-decoration: none;
                    }
                }
            }
        }
    }
}
</style>
